import React, { useEffect, useState } from "react";
import { PageHeader, Modal, Toast, StatusBadge, EmptyState } from "@/components/Layout";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { lock } from "@/lib/perm";
import RowActions from "@/components/RowActions";

export default function Approvals() {
  const { has } = useAuth();
  const [rows, setRows] = useState([]);
  const [detail, setDetail] = useState(null);
  const [rejecting, setRejecting] = useState(null);
  const [comment, setComment] = useState("");
  const [msg, setMsg] = useState({text:"",type:"info"});

  const load = () => api.get("/planco/approvals/pending").then(r=>setRows(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const approve = async (r) => {
    try { await api.post(`/planco/plans/${r.employment_id}/${r.year}/decide`, { decision:"approve", comment:"" });
      load(); setDetail(null); setMsg({text:"Aprobat",type:"success"}); setTimeout(()=>setMsg({text:""}),1500);
    } catch(e){ setMsg({text:e?.response?.data?.detail||"Eroare",type:"error"}); }
  };
  const reject = async () => {
    if (!comment.trim()) { setMsg({text:"Comentariul este obligatoriu (BR-042)",type:"error"}); return; }
    try { await api.post(`/planco/plans/${rejecting.employment_id}/${rejecting.year}/decide`, { decision:"reject", comment });
      setRejecting(null); setComment(""); setDetail(null); load();
      setMsg({text:"Respins",type:"success"}); setTimeout(()=>setMsg({text:""}),1500);
    } catch(e){ setMsg({text:e?.response?.data?.detail||"Eroare",type:"error"}); }
  };

  return (
    <>
      <PageHeader title="Documente în așteptare" subtitle={`${rows.length} programări în așteptare`} />
      <Toast msg={msg.text} type={msg.type} />
      <div className="card">
        <table className="tbl">
          <thead><tr><th>Marcă</th><th>Angajat</th><th>Departament</th><th>An</th><th className="tabular-nums">Zile</th><th className="tabular-nums">Perioade</th><th></th></tr></thead>
          <tbody>{rows.map(r=>(
            <tr key={r.id} data-testid={`appr-row-${r.marca}`}>
              <td style={{fontWeight:600}} className="tabular-nums">{r.marca}</td>
              <td>{r.person_name}</td>
              <td>{r.org_unit_name}</td>
              <td>{r.year}</td>
              <td className="tabular-nums" style={{fontWeight:600}}>{r.total_days}</td>
              <td className="tabular-nums">{r.periods.length}</td>
              <td>
                <RowActions testid={`row-menu-${r.marca}`} items={[
                  {label:"Detalii", icon:"eye", onClick:()=>setDetail(r), testid:`view-${r.marca}`},
                  {label:"Aprobă", icon:"check", blue:true, onClick:()=>approve(r), testid:`approve-${r.marca}`, ...lock(has("planning.decide"))},
                  {label:"Respinge", icon:"close", danger:true, btnDanger:true, onClick:()=>setRejecting(r), testid:`reject-${r.marca}`, ...lock(has("planning.decide"))},
                ]} />
              </td>
            </tr>
          ))}</tbody>
        </table>
        {rows.length===0 && <EmptyState text="Nicio cerere în așteptare pentru aria dvs." />}
      </div>

      {detail && (
        <Modal title={`Detalii — ${detail.person_name}`} onClose={()=>setDetail(null)}>
          <div style={{marginBottom:14,fontSize:13,color:"#64748B"}}>
            Marcă: <b style={{color:"var(--navy)"}}>{detail.marca}</b> · Departament: <b style={{color:"var(--navy)"}}>{detail.org_unit_name}</b>
          </div>
          <table className="tbl" style={{border:"1px solid #E2E8F0",borderRadius:6,overflow:"hidden"}}>
            <thead><tr><th>Perioada</th><th className="tabular-nums">Zile</th><th>Observații</th></tr></thead>
            <tbody>{detail.periods.map(p=>(
              <tr key={p.id}><td>{p.start_date} → {p.end_date}</td><td className="tabular-nums">{p.days}</td><td style={{color:"#64748B"}}>{p.observations || "—"}</td></tr>
            ))}</tbody>
          </table>
        </Modal>
      )}

      {rejecting && (
        <Modal title="Respinge programarea" onClose={()=>{setRejecting(null);setComment("");}}>
          <div style={{marginBottom:12,fontSize:14}}>Respingi programarea pentru <b>{rejecting.person_name}</b> (marca {rejecting.marca})?</div>
          <label className="label label-req">Motiv (obligatoriu — BR-042)</label>
          <textarea className="textarea" rows={4} value={comment} onChange={e=>setComment(e.target.value)} data-testid="reject-comment" />
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:16}}>
            <button className="btn btn-secondary" onClick={()=>{setRejecting(null);setComment("");}}>Anulează</button>
            <button className="btn btn-danger" onClick={reject} data-testid="confirm-reject">Respinge</button>
          </div>
        </Modal>
      )}
    </>
  );
}
